<template>

    <form-group :validator="v" :label="label" :label-for="id" :description="tip">
        <template slot-scope="{ attrs, listeners }">
            <b-form-input :id="id" v-model="text"
                type="number"
                min="0"
                v-bind="attrs"
                :state="v.$dirty ? !v.$error : null"
                v-on="listeners"
                :data-test="slug"
                :readonly="plaintext"
                :required="isRequired ? true : false"
                >
            </b-form-input>
        </template>
    </form-group>
    
</template>

<script>
import _ from "lodash"
 

export default {

    props: {
        value: [Number],
        v: [Object],
        label: [String],
        tip: [String],
        slug: [String],
        required: Boolean,
        plaintext: Boolean,
        setId: [String]
    },
    data() {
      return {
        money: {
          decimal: '.',
          thousands: ',',
          prefix: '$ ',
          suffix: ' / hr',
          precision: 2,
          masked: false /* doesn't work with directive */
        }
      }
    },
    computed: {
        id() {
            if (this.setId === null) {
                return _.uniqueId('moneyInput')
            } else {
                return this.setId
            }
        },
        text: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        },
        isRequired: {
            get() {
                return this.required
            }
        }   
    }
}
</script>
<style>
.form-group > label {
    font-size: inherit;
    font-weight: 400;
}
</style>